import { ref, get } from 'firebase/database';
import { database } from '../../firebase';

export const checkAdminAccess = async (email: string): Promise<boolean> => {
  try {
    const adminUsersRef = ref(database, 'adminUsers');
    const snapshot = await get(adminUsersRef);
    
    if (snapshot.exists()) {
      const adminUsers = snapshot.val();
      return Object.values(adminUsers).some(admin => admin.email.toLowerCase() === email.toLowerCase());
    }
    
    return false;
  } catch (error) {
    console.error('Error checking admin access:', error);
    return false;
  }
};
